module.exports = __webpack_public_path__ + "img/B_Logo_C.6a85cac8.svg";